<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tab
          v-if="mostrarVista(41)"
          href="#catalogos"
          @click="actualizarItems('catalogos')"
        >
          Catálogos
        </v-tab>
        <v-tab
          v-if="mostrarVista(42)"
          href="#puestos"
          @click="actualizarItems('puestos')"
        >
          Puestos
        </v-tab>


        <v-tab
          v-if="mostrarVista(18)"
          href="#empleados"
          @click="actualizarItems('empleados')"
        >
          Empleados
        </v-tab>

        <v-tab
          v-if="mostrarVista(29)"
          href="#empleados_validar"
          @click="actualizarItems('empleados_validar')"
        >
          Expedientes <br>por validar
        </v-tab>

        <v-tab
          v-if="mostrarVista(29)"
          href="#empleados_solicitud_cambios"
          @click="actualizarItems('empleados_solicitud_cambios')"
        >
          Solicitud de cambios <br> de expediente
        </v-tab>

        <v-tab
          v-if="mostrarVista(43)"
          href="#puestos_sueldos"
          @click="actualizarItems('puestos_sueldos')"
        >
          Sueldos y <br> Puestos
        </v-tab>

        <v-tab
          v-if="mostrarVista(44)"
          href="#contratos"
          @click="actualizarItems('contratos')"
        >
          Contratos
        </v-tab>

        <v-tab
          v-if="mostrarVista(44)"
          href="#adendas"
          @click="actualizarItems('adendas')"
        >
          Adendas
        </v-tab>
        
        <v-tab
          v-if="vinculado"
          href="#expediente"
          @click="actualizarItems('expediente')"
        >
          Mi Expediente
        </v-tab>

        <!-- Mockups
        <v-tab
          href="#tabulador_puestos"
          @click="actualizarItems('tabulador_puestos')"
        >
          Tabulador <br> de Puestos
        </v-tab>
        <v-tab
          href="#matriz_solicitudes_puestos"
          @click="actualizarItems('matriz_solicitudes_puestos')"
        >
          Matriz de Solicitudes <br> de Puestos
        </v-tab>
        <v-tab
          href="#solicitud_vacantes"
          @click="actualizarItems('solicitud_vacantes')"
        >
          Solicitudes <br> de Vacantes
        </v-tab>
        <v-tab
          href="#autorizacion_vacantes"
          @click="actualizarItems('autorizacion_vacantes')"
        >
          Autorización <br> de Vacantes
        </v-tab>
        -->
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="mostrarVista(18)"
          value="empleados"
        >
          <empleados
            ref="empleados"
          ></empleados>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(29)"
          value="empleados_validar"
        >
          <empleados-validar
            ref="empleados_validar"
          ></empleados-validar>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(29)"
          value="empleados_solicitud_cambios"
        >
          <solicitudes-cambios
            ref="empleados_solicitud_cambios"
          ></solicitudes-cambios>
        </v-tab-item>

        <v-tab-item
          v-if="vinculado"
          value="expediente"
        >
          <mis-expedientes
            ref="expediente"
          ></mis-expedientes>
        </v-tab-item>

        
        <v-tab-item
          v-if="mostrarVista(41)"
          value="catalogos"
        >
          <catalogos
            ref="catalogos"
          ></catalogos>
        </v-tab-item>
        <v-tab-item
          v-if="mostrarVista(42)"
          value="puestos"
        >
          <puestos
            ref="puestos"
          ></puestos>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(43)"
          value="puestos_sueldos"
        >
          <puestos-sueldos
            ref="puestos_sueldos"
          ></puestos-sueldos>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(44)"
          value="contratos"
        >
          <contratos
            ref="contratos"
          ></contratos>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(44)"
          value="adendas"
        >
          <adendas
            ref="adendas"
          ></adendas>
        </v-tab-item>

        <!-- Mockups -->
        <v-tab-item
          value="tabulador_puestos"
        >
          <tabulador-puestos
            ref="tabulador_puestos"
          ></tabulador-puestos>
        </v-tab-item>
        
        <v-tab-item
          value="matriz_solicitudes_puestos"
        >
          <matriz-solicitudes-puestos
            ref="tabulador_puestos"
          ></matriz-solicitudes-puestos>
        </v-tab-item>

        <v-tab-item
          value="solicitud_vacantes"
        >
          <solicitud-vacantes
            ref="solicitud_vacantes"
          ></solicitud-vacantes>
        </v-tab-item>
        <v-tab-item
          value="autorizacion_vacantes"
        >
          <autorizacion-vacantes
            ref="autorizacion_vacantes"
          ></autorizacion-vacantes>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Empleados from './RecursosHumanos/Empleados.vue'
import EmpleadosValidar from './RecursosHumanos/EmpleadosValidar.vue'
import SolicitudesCambios from './RecursosHumanos/SolicitudesCambios.vue'
import MisExpedientes from './RecursosHumanos/MisExpedientes.vue'
import SolicitudVacantes from './RecursosHumanos/SolicitudVacantes.vue'
import AutorizacionVacantes from './RecursosHumanos/AutorizacionVacantes.vue'
import Catalogos from './RecursosHumanos/Catalogos.vue'
import Puestos from './RecursosHumanos/Puestos.vue'
import TabuladorPuestos from './RecursosHumanos/TabuladorPuestos.vue'
import MatrizSolicitudesPuestos from './RecursosHumanos/MatrizSolicitudesPuestos.vue'
import { mapState } from 'vuex'
import PuestosSueldos from './RecursosHumanos/PuestosSueldos.vue'
import Contratos from './RecursosHumanos/Contratos.vue'
import Adendas from './RecursosHumanos/Adendas.vue'

export default {
  computed: {
    ...mapState(['ids_vistas', 'vinculado'])
  },
  components:{
    Empleados,
    EmpleadosValidar,
    SolicitudesCambios,
    SolicitudVacantes,
    AutorizacionVacantes,
    Catalogos,
    Puestos,
    TabuladorPuestos,
    MatrizSolicitudesPuestos,
    PuestosSueldos,
    Contratos,
    MisExpedientes,
    Adendas
  },
  data: () => ({
    tab: null
  }),
  methods: {
    mostrarVista(id_vista){
			if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
			return (this.ids_vistas.indexOf(id_vista) >= 0);
		},
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    },
    gotoExpediente(){
      this.tab = 'expediente';
    }
  }
}
</script>